import {
  FormInput,
  FormDropDown,
  FormDatepicker,
} from '../../forms/final-form-fields'
import { defineMessages, useIntl } from 'react-intl'

import FormCheckbox from '../../forms/final-form-fields/FormCheckbox'

const messages = defineMessages({
  divingExperience: {
    id: 'myDetails.screen.title.diving.experience',
    defaultMessage: 'Diving Experience',
  },
  certification: {
    id: 'profile.form.certification',
    defaultMessage: 'Highest dive certification level',
  },
  agency: {
    id: 'profile.form.agency',
    defaultMessage: 'Certifying agency',
  },
  nitrox: {
    id: 'profile.form.nitrox',
    defaultMessage: 'Nitrox certified',
  },
  available: {
    id: 'profile.form.available',
    defaultMessage:
      'If available and free, should nitrox be requested by default?',
  },
  numOfDives: {
    id: 'profile.form.numOfDives',
    defaultMessage: 'Approx. number of logged dives',
  },
  lastDate: {
    id: 'profile.form.lastDate',
    defaultMessage: 'Approx. date of last dive',
  },
})

function ParticipantForm({ field, values = {}, productType }) {
  const intl = useIntl()
  const DIVE_CERTIFICATION_AGENCY = window.info.DIVE_CERTIFICATION_AGENCY
  const CERTIFICATION_LEVEL = window.info.account.CERTIFICATION_LEVEL
  const isDivingFieldsRequired = [10, 20, 30].includes(productType)
  return (
    <div className='dive-experience-form'>
      <p className='form-subtitle'>
        {intl.formatMessage(messages.divingExperience)}
      </p>
      <div className='form-row'>
        <FormDropDown
          name={`${field}.certifyingAgency`}
          title={messages.agency}
          isRequired={isDivingFieldsRequired}
          optionLabelKey='agency'
          options={DIVE_CERTIFICATION_AGENCY}
        />
        <FormDropDown
          name={`${field}.certificationLevel`}
          title={messages.certification}
          isRequired={isDivingFieldsRequired}
          isArrayCollection
          options={CERTIFICATION_LEVEL}
        />
      </div>
      <div className='form-row'>
        <FormInput
          name={`${field}.numberOfDives`}
          label={messages.numOfDives}
          onlyNumbers
          isRequired={isDivingFieldsRequired}
        />
        <FormDatepicker
          name={`${field}.lastDiveDate`}
          label={messages.lastDate}
          maxDate={new Date()}
          isRequired={isDivingFieldsRequired}
        />
      </div>
      <div className='form-row'>
        <FormCheckbox
          name={`${field}.isNitroxCertified`}
          label={messages.nitrox}
        />
        {values.isNitroxCertified && (
          <FormCheckbox
            name={`${field}.isNitroxDefault`}
            label={messages.available}
          />
        )}
      </div>
    </div>
  )
}

export default ParticipantForm
